import i18n from '@quizzach/i18n';

// cart prices stay formal: always two decimals, comma separator (10,00 EUR),
// unlike premade cards which drop the trailing .00
export const formatCartPrice = (price?: string | number) =>
	price !== undefined && price !== null && price !== ''
		? Number(price).toFixed(2).replace('.', ',')
		: undefined;

export const handleQuizType = (
	type: string,
	question_num?: number,
	premade_name?: string,
	reserved_questions_count?: number,
	author?: string
) => {
	const checkAuthor = (author: string | undefined) => {
		if (author === 'quizzach') return '';
		else if (author) return i18n.t('cart.quizType.byAuthor', { author });
		else return '';
	};

	switch (type) {
		case 'quick':
			return i18n.t('cart.quizType.quick', { num: question_num });
		case 'generator':
			return i18n.t('cart.quizType.generator', {
				num: reserved_questions_count && reserved_questions_count - 1,
			});
		case 'premade':
			return `${premade_name} ${checkAuthor(author)} `;
		default:
			return '';
	}
};
